// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".slide-image[data-v-d21c60fe]{height:200px;aspect-ratio:16/9;-o-object-fit:cover;object-fit:cover}@media (min-width: 1024px){.slide-image[data-v-d21c60fe]{height:300px;aspect-ratio:16/9;-o-object-fit:cover;object-fit:cover}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
